<div
  class="flex flex-row w-5 align-content-center align-items-center min-w-full justify-content-center align-self-center"
>
  <p-card class="align-self-center">
    <p-image src="./assets/img/error-404.png" width="900"> </p-image>
  </p-card>
</div>
<!-- <button pButton (click)="goToStart()">Volver al inicio</button> -->
